import { initVisionneuse } from "../modules/visionneuse";
import { DetailsDialog } from "../modules/details";
import { PopularProductList } from "../modules/popular-product-list";
import { UpsellProductTypeManager } from "../modules/upsell-preview";
import { initColorSwatchListener, hydrateRelatedProductsOverflow } from "../modules/product-variant";
import { Dialog, initDeviceDialogs } from "../modules/dialog";
import { initKitAddToCartOverride } from "../modules/kit-atc-override";
import { initPopularAtc } from "../modules/popular-atc";
import "../modules/product-type-switcher";
import "../modules/template-download";
function initKitCardPreviews(): void {
  const kitCardsWithRows = new Set<HTMLElement>();
  document.querySelectorAll<HTMLElement>('.kit-card--row:not([data-preview-ready])').forEach((row) => {
    const kitCard = row.closest<HTMLElement>('.kit-card');
    if (kitCard) kitCardsWithRows.add(kitCard);
  });
  kitCardsWithRows.forEach((kitCard) => {
    kitCard.querySelectorAll<HTMLElement>('.kit-card--row').forEach((r) => {
      r.dataset.previewReady = 'true';
    });
    new UpsellProductTypeManager(kitCard);
  });
}

function initFaqAccordion(): void {
  document.querySelectorAll<HTMLElement>('.faq-content-dialog-content').forEach((container) => {
    container.addEventListener('toggle', (e) => {
      const opened = e.target as HTMLDetailsElement;
      if (!opened.open) return;
      container.querySelectorAll<HTMLDetailsElement>('details').forEach((details) => {
        if (details !== opened) details.removeAttribute('open');
      });
    }, true);
  });
}

let bundleTabLoaded = false;

function initProductSideTabs(): void {
  const tabs = document.querySelectorAll<HTMLButtonElement>('[data-product-side-tab]');
  const panels = document.querySelectorAll<HTMLElement>('[data-tab-content]');
  if (!tabs.length) return;

  const buyButtonContainers = document.querySelectorAll<HTMLElement>('.product-buy-button--container .product-form');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.productSideTab;
      tabs.forEach((t) => t.classList.toggle('--active', t === tab));
      panels.forEach((p) => { p.hidden = p.dataset.tabContent !== target; });
      buyButtonContainers.forEach((el) => { el.hidden = target === 'bundles'; });

      if (target === 'bundles' && !bundleTabLoaded) {
        bundleTabLoaded = true;
        void loadBundleTab();
      }
    });
  });
}

async function loadBundleTab(): Promise<void> {
  await import('./product-bundle-tab');
}

const init = (): void => {
  document.documentElement.dataset.viteProduct = "ready";
  
  initVisionneuse();
  initColorSwatchListener();
  hydrateRelatedProductsOverflow();
  const dialog = document.querySelector<HTMLDialogElement>("#my-dialog")!;
  if (dialog) {
    const buttonList = document.querySelectorAll<HTMLButtonElement>(".faq-content--buttons");
    const buttonClose = document.querySelector<HTMLButtonElement>(".dialog-close")!;

    new DetailsDialog(buttonList, dialog, buttonClose);
  }
  const dots = document.querySelectorAll<HTMLSpanElement>(".popular-content-footer-dots-dot");
  const liste = document.querySelector<HTMLElement>(".popular-content-liste")!;
  if (liste) {
    const btnLeft = document.querySelector<HTMLButtonElement>(".popular-content-footer-buttons--btnLeft")!;
    const btnRight = document.querySelector<HTMLButtonElement>(".popular-content-footer-buttons--btnRight")!;
    new PopularProductList(dots, liste, btnLeft, btnRight);
  }

  initKitCardPreviews();
  document.addEventListener("kits:replaced", initKitCardPreviews);
  initDeviceDialogs();

  document.querySelectorAll<HTMLElement>("[data-help-trigger]").forEach((btn) => {
    const dialogId = btn.dataset.helpTrigger;
    if (!dialogId) return;
    const dialog = document.getElementById(dialogId) as HTMLDialogElement | null;
    if (!dialog) return;
    const closeBtns = dialog.querySelectorAll<HTMLElement>("[data-dialog-toggle]");
    new Dialog(dialog, [btn], closeBtns);

    if (dialogId.startsWith("dialog-case-type-help-")) {
      btn.addEventListener("click", () => {
        const selectedBtn = document.querySelector<HTMLButtonElement>('.variants-case .button-toggle[data-selected="true"]');
        if (!selectedBtn) return;
        const value = selectedBtn.value.toLowerCase();
        const tabTarget = value.includes("gloss") || value.includes("lustré") ? "gloss" : "mat";
        dialog.querySelector<HTMLButtonElement>(`[data-target="${tabTarget}"]`)?.click();
      });
    }

    const sticky = document.querySelector('.product-buy-button--container');
    const sentinel = document.querySelector('.product-buy-button-sentinel');
    if (!sticky || !sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        // Quand le sentinelle sort du viewport vers le haut, la div devient sticky
        if (!entry.isIntersecting) {
          sticky.classList.add('is-sticky');
        } else {
          sticky.classList.remove('is-sticky');
        }
      },
      { threshold: [0] }
    );

    observer.observe(sentinel);

  });

  initKitAddToCartOverride();
  initPopularAtc();
  initFaqAccordion();
  initProductSideTabs();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
